import { Pipe, PipeTransform } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";

@Pipe({
	name: "largeNumber",
	standalone: false
})
export class LargeNumberPipe implements PipeTransform {
	private powers: Map<string, number> = new Map([]);

	public constructor(private translationService: TranslationService) {
		this.initPowers();
	}

	public transform(val: string | number, round: boolean = true): string {
		const num = +val;
		if (!num || isNaN(num)) {
			return "" + num;
		}

		let abs = Math.abs(num);
		const rounder = Math.pow(10, 1);

		let shorthand = "";
		for (const key of this.powers.keys()) {
			let reduced = abs / this.powers.get(key);
			if (round) {
				reduced = Math.round(reduced * rounder) / rounder;
			}
			if (reduced >= 1) {
				abs = reduced;
				shorthand = key;
				break;
			}
		}

		return (num < 0 ? "-" : "") + abs + shorthand;
	}

	private translate(key: string): string {
		return this.translationService.translate(key);
	}

	private initPowers(): void {
		this.powers = new Map([
			[this.translate("abbrev_quadrillion"), Math.pow(10, 15)],
			[this.translate("abbrev_trillion"), Math.pow(10, 12)],
			[this.translate("abbrev_billion"), Math.pow(10, 9)],
			[this.translate("abbrev_million"), Math.pow(10, 6)]
		]);
	}
}
